//==============================================================================
/**
 * all available message types to keep parent/child communication straight
 * @type {object} pseudo-constant
 */
const GyroErrors =
  {
    UNKNOWN         : "1",
    NOT_INITIALIZED : "2",
    NO_GYRO         : "3",
    INITIALIZING    : "4",
    REQUESTING      : "5",
    ENABLING        : "6",
    DISABLING       : "7",
    STATUS_UNKNOWN  : "8",
    STATUS_DENIED   : "9"
  };

// defaults, but can be changed
const GyroErrorMessages = 
  {
    "1" : "An unknown error has occurred.",
    "2" : "Library has not been initialized.",
    "3" : "Device has no gyroscope.",
    "4" : "Library is actively initializing.",
    "5" : "Library is actively requesting permissions.",
    "6" : "Library is actively enabling",
    "7" : "Library is actively disabling",
    "8" : "Gyroscope permissions are unknown or an error occurred with the request.",
    "9" : "Gyroscope permissions are currently denied."
  };


export { GyroErrors, GyroErrorMessages };




